import { AppState } from './store';
import { initialState as authState } from './state/authSlice';
import { initialState as channelsState } from './state/channelsSlice';
import { initialState as chatState } from './state/chatSlice';
import { initialState as feedState } from './state/feedSlice';
import { initialState as likesState } from './state/likesSlice';
import { initialState as participantsState } from './state/participantsSlice';
import { initialState as requestsToSpeakState } from './state/requestsToSpeakSlice';
import { initialState as searchState } from './state/searchSlice';
import { initialState as showsState } from './state/showsSlice';
import { initialState as speakersState } from './state/speakersSlice';
import { initialState as teamsState } from './state/teamsSlice';
import { initialState as topicsState } from './state/topicsSlice';
import { initialState as usersState } from './state/usersSlice';

export const initialState = {
  auth: authState,
  channels: channelsState,
  chat: chatState,
  feed: feedState,
  likes: likesState,
  participants: participantsState,
  requestsToSpeak: requestsToSpeakState,
  search: searchState,
  shows: showsState,
  speakers: speakersState,
  teams: teamsState,
  topics: topicsState,
  users: usersState,
} as AppState;
